<template>
  <div class="consent-web">
    <gd-modal v-if="showSettings">
      <modal-app m>
        <modal-layout>
          <consent-settings @close="onCloseSettings"></consent-settings>
        </modal-layout>
      </modal-app>
    </gd-modal>
    <consent-banner v-if="showBanner" @on-settings="onShowSettings" @close="onCloseBanner"></consent-banner>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Storage, STORE_NAME, GD } from '@gd/storage'
import ConsentBanner from './components/ConsentBanner.vue'
import ConsentSettings from './components/ConsentSettings.vue'
import { getCookieProperty } from './lib/cookie'
import { postSettings } from './lib/request'
import { setupComponentI18n } from '@gd/i18n'
import { ACTION } from '@gd/tracking'
import { track } from './lib/track'
import { events } from '@gd/event-bus'

setupComponentI18n()
const showSettings = ref(false)
const showBanner = ref(false)

function executeInitialShowConditions() {
  const storage = new Storage()
  const gdStorage: GD = storage.read(STORE_NAME.GD)
  const cookieConsent = getCookieProperty(document.cookie, 'cookieConsent')
  // auto=true: we accepted all the consent for the user - (except he has already accepted)
  const autoFlag = gdStorage.cookieConsent.auto || false
  // detects a user from US,.com, GeoIp as a "cookie auto accept"-user
  if (gdStorage.decisions.includes('fe-cookie-consent-auto')) {
    if (!autoFlag && cookieConsent?.consented !== true) {
      // post with auto: true - will tell backend to accept all cookies but let the "cookieConsent.consented:false"
      postSettings({ functional: true, marketing: true, auto: true })
      track({
        id: 'consent_auto',
        action: ACTION.autoCookieConsent,
      })
    } else {
      track({
        id: 'consent_auto',
        action: ACTION.autoCookieContinued,
      })
    }
    showBanner.value = false
  }
  // If localStorage.cookieConsent not present or x.consented === false (very unlikely) show footer-banner
  else if (cookieConsent?.consented !== true) {
    showBanner.value = true
  }
}

function onShowSettings() {
  showSettings.value = true
  showBanner.value = false
}

function onCloseSettings() {
  showSettings.value = false
}
function onCloseBanner() {
  showBanner.value = false
}

executeInitialShowConditions()
//React on event-bus' event - might be dispatched elsewhere on the website
events.$on('consent-settings', onShowSettings)
// e.g. required to execut (in SPA) after a login to detect if a` user still matches the "auto: accept" - conditions
events.$on('consent-reinitialize', executeInitialShowConditions)
</script>

<style lang="less">
.consent-web {
  * {
    box-sizing: border-box;
  }
  // make sure it is above everything
  // gd/modal has 100001
  // colorBox has: 100000
  position: relative;
  z-index: 999999; // max z-index
  .modal-layout {
    padding: 0;
  }
}
// t-container is alligned specially for the classic g940 content
.g940 .consent-web .t-container {
  max-width: 940px !important;
}
</style>
